import { useCallback } from 'react';

import { useRumError } from '@mint-lib/datadog';

export const useShouldNeverHappen = () => {
  const rumError = useRumError();

  return useCallback(
    (message: string) => rumError(new Error(message), {}, 'custom'),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );
};
